import React from 'react';
import styled from '@emotion/styled';

const Image = styled.img`
  display: ${props => (props.displayBlock ? 'block' : 'inline-block')};
  ${props => {
    if (!props.imgFitContain && !props.imgFitCover) {
      return 'max-width: 100%; max-height: 100%;';
    }
  }}
  ${props => {
    if (!props.imgFitContain && !props.imgFitCover) {
      let string;
      string = 'height: ';
      props.imgHeight ? (string += props.imgHeight) : (string += 'auto');
      string += ';';
      string += 'width: ';
      props.imgWidth ? (string += props.imgWidth) : (string += 'auto');
      string += ';';
      return string;
    } else {
      return 'height: 100%; width: 100%; object-position: center;';
    }
  }};
  ${props => (props.imgFitContain ? 'object-fit: contain;' : null)}
  ${props =>
    props.imgFitCover ? 'object-fit: cover;' : null}
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${props => (props.marginBottom ? '1rem' : '0')};
  ${props => {
    if (props.isAnAvatar) {
      let avatarString;
      avatarString =
        'width: 3.375rem; height: auto; position: absolute; z-index: 2; border-width: 2px; border-style: solid; border-radius: 100%;';
      return avatarString;
    }
  }};
  border-width: ${props => {
    if (props.publicationCountryColor) {
      return '1px';
    }
    if (props.isAThumbnail) {
      return '.5rem';
    }
    return '0';
  }};
  border-style: solid;
  border-color: ${props => {
    if (props.publicationCountryColor) {
      return props.publicationCountryColor;
    }
    if (props.isAThumbnail) {
      return props.theme.lightColor;
    }
    return props.theme.primaryCountryColor;
  }};
  border-radius: ${props => {
    if (props.isAnAvatar) {
      if (props.isAvatarSquared) {
        return '.25rem';
      }
      return '100%';
    }
    return '0';
  }};
  box-shadow: ${props =>
    props.isAThumbnail ? '0 0 .5rem rgba(0,0,0,.15)' : 'none'};
  ${props => (props.isAThumbnail ? 'max-height: 12rem;' : null)};
  ${props => (props.maxHeight ? 'max-height: ' + props.maxHeight + ';' : null)};
`;
class Img extends React.Component {
  render() {
    return (
      <Image
        src={this.props.src}
        imgWidth={this.props.imgWidth}
        imgHeight={this.props.imgHeight}
        width={this.props.width}
        height={this.props.height}
        alt={this.props.alt}
        title={this.props.title}
        marginBottom={this.props.marginBottom}
        imgFitContain={this.props.imgFitContain}
        imgFitCover={this.props.imgFitCover}
        isAnAvatar={this.props.isAnAvatar}
        isAvatarSquared={this.props.isAvatarSquared}
        publicationCountryColor={this.props.publicationCountryColor}
        displayBlock={this.props.displayBlock}
        isAThumbnail={this.props.isAThumbnail}
        floatLeft={this.props.floatLeft}
        maxHeight={this.props.maxHeight}
      />
    );
  }
}

export default Img;
